import { RouteEnum } from '@shared/enum/route.enum';
import { IStoreRouterState } from './router.interface';

/**
 * Set
 * @param {IStoreRouterState} that
 * @param {RouteEnum} link
 */
export function _setActiveRoute(that: IStoreRouterState, route?: RouteEnum) {
  that.activeRoute = route ?? RouteEnum.HOME;
}

/**
 * Increase opened modal number
 * @param {IStoreRouterState} that
 */
export function _addOpenedModal(that: IStoreRouterState, uuid: string) {
  if (that.modalsOpened != null && !that.modalsOpened.includes(uuid)) {
    that.modalsOpened.push(uuid);
  } else {
    that.modalsOpened = [uuid];
  }
}

/**
 * Decrease opened modal number
 * @param {IStoreRouterState} that
 */
export function _removeOpenedModal(that: IStoreRouterState, uuid: string) {
  if (that.modalsOpened != null && that.modalsOpened.includes(uuid)) {
    that.modalsOpened.splice(that.modalsOpened.indexOf(uuid), 1);
  }
}

/**
 * Clear opened modal number
 * @param {IStoreRouterState} that
 */
export function _clearOpenedModal(that: IStoreRouterState) {
  that.modalsOpened = [];
}

/**
 * Get last inserted
 * @param {IStoreRouterState} that
 */
export function _getLastInserted(that: IStoreRouterState): string | undefined {
  if (that.modalsOpened != null && that.modalsOpened.length > 0) {
    return that.modalsOpened[that.modalsOpened.length - 1];
  } else {
    return undefined;
  }
}
